import makeStyles from '@mui/styles/makeStyles'
import { tokens } from './tokens'

// Jednotna hlavicka karet: plnobarevny navy gradient pas pres celou
// sirku horni hrany karty (varianta A schvalena 8.7.2026).
// Zaporne marginy kompenzuji 16px padding CardWrapperu. Radius je jen
// na hornich rozich - pas kopiruje horni hranu karty a zespodu je
// useknuty rovne (stejne jako hlavicka karet v modulu Fond).
export const useCardHeaderStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '12px',
    background: `linear-gradient(135deg, ${tokens.color.primary[800]}, ${tokens.color.primary[600]})`,
    margin: '-16px -16px 20px',
    padding: '12px 16px',
    borderRadius: `${tokens.radius.lg} ${tokens.radius.lg} 0 0`,
    minHeight: '48px',
  },
  title: {
    fontFamily: tokens.font.display,
    fontSize: '0.9375rem',
    fontWeight: 600,
    color: tokens.color.white,
    letterSpacing: '-0.01em',
    lineHeight: 1.3,
    margin: 0,
  },
  value: {
    fontSize: '0.9375rem',
    fontWeight: 600,
    color: tokens.color.white,
    fontVariantNumeric: 'tabular-nums',
    whiteSpace: 'nowrap',
    margin: 0,
  },
}))

// Akcni tlacitko v navy hlavicce karty. Vychozi MUI varianta je modra a na
// navy gradientu je prakticky neviditelna, proto bila outline varianta.
// Pouziva se pres `sx`, aby prebilo vychozi styly MuiButtonu.
export const cardHeaderActionSx = {
  color: tokens.color.white,
  borderColor: 'rgba(255, 255, 255, 0.6)',
  backgroundColor: 'rgba(255, 255, 255, 0.08)',
  '&:hover': {
    borderColor: tokens.color.white,
    backgroundColor: 'rgba(255, 255, 255, 0.18)',
  },
}
